import BookDetail from './BookDetail';

export default BookDetail;
